import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { TabPanel } from '../utils/TabPanelShim';
const debug = process.env.REACT_APP_DEBUG && false;
export const SlaveTab = ({ orderedComponents, value, index }) => {
    let renderedComponents = null;
    if (value === index) {
        renderedComponents = orderedComponents.map((component) => component());
    }
    else {
        debug && console.log('not rendering for ', { value, index });
    }
    return (_jsx(TabPanel, { value, index, children: _jsx(Stack, { children: renderedComponents || _jsx("div", { children: "Nothing" }) }, `tabPanelGrid_${index}`) }, `tabPanel_${index}`));
};
